import types from './types';

const INITIAL_STATE = {
  isFetchingCount: false,
  isFetchingRow1: false,
  isFetchingRow2: false,

  result: [],
};

const eligibilityMembersReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

     case types.GET_MEMBER_ALERT_COUNT_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingCount: true,
      };

    case types.GET_MEMBER_ALERT_COUNT_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingCount: false,
      };

    case types.GET_MEMBER_ALERT_COUNT_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingCount: false,
      };

    case types.GET_MEMBERS_FOR_ALERTS_ROW_1_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingRow1: true,
      };

    case types.GET_MEMBERS_FOR_ALERTS_ROW_1_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingRow1: false,
      };

    case types.GET_MEMBERS_FOR_ALERTS_ROW_1_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingRow1: false,
      };

    case types.GET_MEMBERS_FOR_ALERTS_ROW_2_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingRow2: true,
      };

    case types.GET_MEMBERS_FOR_ALERTS_ROW_2_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingRow2: false,
      };

    case types.GET_MEMBERS_FOR_ALERTS_ROW_2_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingRow2: false,
      };

    default:
      return state;
  }
};

export default eligibilityMembersReducer;
